<div class="nt-dialog">
  <div class="nt-dialog-toolbar">
    <button mat-icon-button type="button" (click)="ajustarZoom(-0.1)" [disabled]="zoom <= 0.8" matTooltip="Diminuir o texto">
      <mat-icon>text_decrease</mat-icon>
    </button>
    <button mat-icon-button type="button" (click)="ajustarZoom(0.1)" [disabled]="zoom >= 1.6" matTooltip="Aumentar o texto">
      <mat-icon>text_increase</mat-icon>
    </button>
    <a mat-icon-button *ngIf="urlPagina" [href]="urlPagina" target="_blank" rel="noopener noreferrer"
       matTooltip="Abrir em nova aba (para imprimir ou compartilhar)">
      <mat-icon>open_in_new</mat-icon>
    </a>
    <span fxFlex></span>
    <button mat-icon-button type="button" (click)="close()" matTooltip="Fechar (Esc)" cdkFocusInitial>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="nt-dialog-content">
    <app-notificacao-card [notificacao]="notificacao" [zoom]="zoom" (acao)="close('acao')"></app-notificacao-card>
  </div>
</div>
